module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clients":"Clients","extension":"Google Chrome Extension","FAQ":"FAQ","about":"What people are saying about Huntica","press":"Huntica in the news","registration":"Registration","slogan":"Huntica is the first automated interview service with a real person","sloganShort":"The first automated interview service with a real person"}}')
  delete Component.options._Ctor
}
